export const defaultFontSize = 68
export const alphabet = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
]

export const fontStyles: Record<
  string,
  { fontStyle: string; fontWeight: number | null }
> = {
  Plain: {
    fontStyle: '',
    fontWeight: 400,
  },
  Bold: {
    fontStyle: '',
    fontWeight: 700,
  },
  Regular: {
    fontStyle: '',
    fontWeight: 400,
  },
  Condensed: {
    fontStyle: '',
    fontWeight: 400,
  },
  'Condensed Bold': {
    fontStyle: '',
    fontWeight: 700,
  },
  'Condensed Light': {
    fontStyle: '',
    fontWeight: 300,
  },
  Light: {
    fontStyle: '',
    fontWeight: 300,
  },
  Semibold: {
    fontStyle: '',
    fontWeight: 600,
  },
  Chancery: {
    fontStyle: '',
    fontWeight: null,
  },
  'Outline ': {
    fontStyle: '',
    fontWeight: null,
  },
  Pinpoint: {
    fontStyle: '',
    fontWeight: null,
  },
  ExtraBold: {
    fontStyle: '',
    fontWeight: 950,
  },
  Heavy: {
    fontStyle: '',
    fontWeight: 900,
  },
  Medium: {
    fontStyle: '',
    fontWeight: 500,
  },
  SemiBold: {
    fontStyle: '',
    fontWeight: 600,
  },
  Thin: {
    fontStyle: '',
    fontWeight: 100,
  },
  UltraLight: {
    fontStyle: '',
    fontWeight: 200,
  },
  'Bold Italic': {
    fontStyle: 'italic',
    fontWeight: 700,
  },
  Italic: {
    fontStyle: 'italic',
    fontWeight: 400,
  },
  Black: {
    fontStyle: '',
    fontWeight: 900,
  },
  'Black Oblique': {
    fontStyle: 'italic',
    fontWeight: 900,
  },
  Book: {
    fontStyle: '',
    fontWeight: 400,
  },
  'Book Oblique': {
    fontStyle: 'italic',
    fontWeight: 400,
  },
  'Heavy Oblique': {
    fontStyle: 'italic',
    fontWeight: 900,
  },
  'Light Oblique': {
    fontStyle: 'italic',
    fontWeight: 300,
  },
  'Medium Oblique': {
    fontStyle: 'italic',
    fontWeight: 500,
  },
  Oblique: {
    fontStyle: 'italic',
    fontWeight: 400,
  },
  Roman: {
    fontStyle: '',
    fontWeight: null,
  },
  'Demi Bold': {
    fontStyle: '',
    fontWeight: 600,
  },
  'Demi Bold Italic': {
    fontStyle: 'italic',
    fontWeight: 600,
  },
  'Heavy Italic': {
    fontStyle: 'italic',
    fontWeight: 900,
  },
  'Medium Italic': {
    fontStyle: 'italic',
    fontWeight: 500,
  },
  'Ultra Light': {
    fontStyle: '',
    fontWeight: 200,
  },
  'Ultra Light Italic': {
    fontStyle: 'italic',
    fontWeight: 200,
  },
  'Black Italic': {
    fontStyle: 'italic',
    fontWeight: 900,
  },
  'ExtraBold Italic': {
    fontStyle: 'italic',
    fontWeight: 800,
  },

  'Thin Italic': {
    fontStyle: 'italic',
    fontWeight: 100,
  },
  'ExtraLight Italic': {
    fontWeight: 200,
    fontStyle: 'italic',
  },

  // idk
  ExtraLight: {
    fontStyle: '',
    fontWeight: 200,
  },
  Extrathin: {
    fontStyle: '',
    fontWeight: 200,
  },
  'Extrathin Italic': {
    fontStyle: 'italic',
    fontWeight: 100,
  },
  'Light Italic': {
    fontStyle: 'italic',
    fontWeight: 300,
  },
  'Regular Italic': {
    fontStyle: 'italic',
    fontWeight: 400,
  },
  'Semibold Italic': {
    fontStyle: 'italic',
    fontWeight: 500,
  },
  // 'Outline 6 Dot': {
  //   fontStyle: 'italic',

  // },
}

export const defaultAppleFonts = [
  'Academy Engraved LET Plain:1.0',
  'Al Bayan Bold',
  'Al Bayan Plain',
  'Al Nile',
  'Al Nile Bold',
  'Al Tarikh Regular',
  'American Typewriter',
  'American Typewriter Bold',
  'American Typewriter Condensed',
  'American Typewriter Condensed Bold',
  'American Typewriter Condensed Light',
  'American Typewriter Light',
  'American Typewriter Semibold',
  'Andale Mono',
  'Apple Braille',
  'Apple Braille Outline 6 Dot',
  'Apple Braille Outline 8 Dot',
  'Apple Braille Pinpoint 6 Dot',
  'Apple Braille Pinpoint 8 Dot',
  'Apple Chancery',
  'Apple Color Emoji',
  'Apple SD Gothic Neo Bold',
  'Apple SD Gothic Neo Heavy',
  'Apple SD Gothic Neo Light',
  'Apple SD Gothic Neo Medium',
  'Apple SD Gothic Neo Regular',
  'Apple SD Gothic Neo SemiBold',
  'Apple SD Gothic Neo Thin',
  'Apple SD Gothic Neo UltraLight',
  'Apple SD Gothic Neo ExtraBold',
  'Apple Symbols',
  'AppleGothic Regular',
  'AppleMyungjo Regular',
  'Arial',
  'Arial Black',
  'Arial Bold',
  'Arial Bold Italic',
  'Arial Hebrew',
  'Arial Hebrew Bold',
  'Arial Hebrew Light',
  'Arial Hebrew Scholar',
  'Arial Hebrew Scholar Bold',
  'Arial Hebrew Scholar Light',
  'Arial Italic',
  'Arial Narrow',
  'Arial Narrow Bold',
  'Arial Narrow Bold Italic',
  'Arial Narrow Italic',
  'Arial Rounded MT Bold',
  'Arial Unicode MS',
  'Avenir Black',
  'Avenir Black Oblique',
  'Avenir Book',
  'Avenir Book Oblique',
  'Avenir Heavy',
  'Avenir Heavy Oblique',
  'Avenir Light',
  'Avenir Light Oblique',
  'Avenir Medium',
  'Avenir Medium Oblique',
  'Avenir Next Bold',
  'Avenir Next Bold Italic',
  'Avenir Next Condensed Bold',
  'Avenir Next Condensed Bold Italic',
  'Avenir Next Condensed Demi Bold',
  'Avenir Next Condensed Demi Bold Italic',
  'Avenir Next Condensed Heavy',
  'Avenir Next Condensed Heavy Italic',
  'Avenir Next Condensed Italic',
  'Avenir Next Condensed Medium',
  'Avenir Next Condensed Medium Italic',
  'Avenir Next Condensed Regular',
  'Avenir Next Condensed Ultra Light',
  'Avenir Next Condensed Ultra Light Italic',
  'Avenir Next Demi Bold',
  'Avenir Next Demi Bold Italic',
  'Avenir Next Heavy',
  'Avenir Next Heavy Italic',
  'Avenir Next Italic',
  'Avenir Next Medium',
  'Avenir Next Medium Italic',
  'Avenir Next Regular',
  'Avenir Next Ultra Light',
  'Avenir Next Ultra Light Italic',
  'Avenir Oblique',
  'Avenir Roman',
  'Ayuthaya',
  'Baghdad Regular',
  'Bangla MN',
  'Bangla MN Bold',
  'Bangla Sangam MN',
  'Bangla Sangam MN Bold',
  'Baskerville',
  'Baskerville Bold',
  'Baskerville Bold Italic',
  'Baskerville Italic',
  'Baskerville SemiBold',
  'Baskerville SemiBold Italic',
  'Beirut Regular',
  'Big Caslon Medium',
  'Bodoni 72 Bold',
  'Bodoni 72 Book',
  'Bodoni 72 Book Italic',
  'Bodoni 72 Oldstyle Bold',
  'Bodoni 72 Oldstyle Book',
  'Bodoni 72 Oldstyle Book Italic',
  'Bodoni 72 Smallcaps Book',
  'Bodoni Ornaments',
  'Bradley Hand Bold',
  'Brush Script MT Italic',
  'Chalkboard',
  'Chalkboard Bold',
  'Chalkboard SE Bold',
  'Chalkboard SE Light',
  'Chalkboard SE Regular',
  'Chalkduster',
  'Charter Black',
  'Charter Black Italic',
  'Charter Bold',
  'Charter Bold Italic',
  'Charter Italic',
  'Charter Roman',
  'Cochin',
  'Cochin Bold',
  'Cochin Bold Italic',
  'Cochin Italic',
  'Copperplate',
  'Copperplate Bold',
  'Copperplate Light',
  'Corsiva Hebrew',
  'Corsiva Hebrew Bold',
  'Courier',
  'Courier Bold',
  'Courier Bold Oblique',
  'Courier New',
  'Courier New Bold',
  'Courier New Bold Italic',
  'Courier New Italic',
  'Courier Oblique',
  'DIN Alternate Bold',
  'DIN Condensed Bold',
  'Damascus Bold',
  'Damascus Light',
  'Damascus Medium',
  'Damascus Regular',
  'Damascus Semi Bold',
  'DecoType Naskh Regular',
  'Devanagari MT',
  'Devanagari MT Bold',
  'Devanagari Sangam MN',
  'Devanagari Sangam MN Bold',
  'Didot',
  'Didot Bold',
  'Didot Italic',
  'Diwan Kufi Regular',
  'Diwan Thuluth Regular',
  'Euphemia UCAS',
  'Euphemia UCAS Bold',
  'Euphemia UCAS Italic',
  'Farah Regular',
  'Farisi Regular',
  'Futura Bold',
  'Futura Condensed ExtraBold',
  'Futura Condensed Medium',
  'Futura Medium',
  'Futura Medium Italic',
  'GB18030 Bitmap',
  'Galvji',
  'Galvji Bold',
  'Galvji Bold Oblique',
  'Galvji Oblique',
  'Geeza Pro Bold',
  'Geeza Pro Regular',
  'Geneva',
  'Georgia',
  'Georgia Bold',
  'Georgia Bold Italic',
  'Georgia Italic',
  'Gill Sans',
  'Gill Sans Bold',
  'Gill Sans Bold Italic',
  'Gill Sans Italic',
  'Gill Sans Light',
  'Gill Sans Light Italic',
  'Gill Sans SemiBold',
  'Gill Sans SemiBold Italic',
  'Gill Sans UltraBold',
  'Gujarati MT',
  'Gujarati MT Bold',
  'Gujarati Sangam MN',
  'Gujarati Sangam MN Bold',
  'Gurmukhi MN',
  'Gurmukhi MN Bold',
  'Gurmukhi MT',
  'Gurmukhi Sangam MN',
  'Gurmukhi Sangam MN Bold',
  'Heiti SC Light',
  'Heiti SC Medium',
  'Heiti TC Light',
  'Heiti TC Medium',
  'Helvetica',
  'Helvetica Bold',
  'Helvetica Bold Oblique',
  'Helvetica Light',
  'Helvetica Light Oblique',
  'Helvetica Neue',
  'Helvetica Neue Bold',
  'Helvetica Neue Bold Italic',
  'Helvetica Neue Condensed Black',
  'Helvetica Neue Condensed Bold',
  'Helvetica Neue Italic',
  'Helvetica Neue Light',
  'Helvetica Neue Light Italic',
  'Helvetica Neue Medium',
  'Helvetica Neue Medium Italic',
  'Helvetica Neue Thin',
  'Helvetica Neue Thin Italic',
  'Helvetica Neue UltraLight',
  'Helvetica Neue UltraLight Italic',
  'Helvetica Oblique',
  'Herculanum',
  'Hiragino Maru Gothic ProN W4',
  'Hiragino Mincho ProN W3',
  'Hiragino Mincho ProN W6',
  'Hiragino Sans GB W3',
  'Hiragino Sans GB W6',
  'Hiragino Sans W0',
  'Hiragino Sans W1',
  'Hiragino Sans W2',
  'Hiragino Sans W3',
  'Hiragino Sans W4',
  'Hiragino Sans W5',
  'Hiragino Sans W6',
  'Hiragino Sans W7',
  'Hiragino Sans W8',
  'Hiragino Sans W9',
  'Hoefler Text',
  'Hoefler Text Black',
  'Hoefler Text Black Italic',
  'Hoefler Text Italic',
  'Hoefler Text Ornaments',
  'ITF Devanagari Bold',
  'ITF Devanagari Book',
  'ITF Devanagari Demi',
  'ITF Devanagari Light',
  'ITF Devanagari Marathi Bold',
  'ITF Devanagari Marathi Book',
  'ITF Devanagari Marathi Demi',
  'ITF Devanagari Marathi Light',
  'ITF Devanagari Marathi Medium',
  'ITF Devanagari Medium',
  'Impact',
  'InaiMathi',
  'InaiMathi Bold',
  'Kailasa Bold',
  'Kailasa Regular',
  'Kannada MN',
  'Kannada MN Bold',
  'Kannada Sangam MN',
  'Kannada Sangam MN Bold',
  'Kefa Bold',
  'Kefa Regular',
  'Khmer MN',
  'Khmer MN Bold',
  'Khmer Sangam MN',
  'Kohinoor Bangla',
  'Kohinoor Bangla Bold',
  'Kohinoor Bangla Light',
  'Kohinoor Bangla Medium',
  'Kohinoor Bangla Semibold',
  'Kohinoor Devanagari Bold',
  'Kohinoor Devanagari Light',
  'Kohinoor Devanagari Medium',
  'Kohinoor Devanagari Regular',
  'Kohinoor Devanagari Semibold',
  'Kohinoor Gujarati Bold',
  'Kohinoor Gujarati Light',
  'Kohinoor Gujarati Regular',
  'Kohinoor Telugu',
  'Kohinoor Telugu Bold',
  'Kohinoor Telugu Light',
  'Kohinoor Telugu Medium',
  'Kohinoor Telugu Semibold',
  'Kokonor Regular\t',
  'Krungthep',
  'KufiStandardGK Regular',
  'Lao MN',
  'Lao MN Bold',
  'Lao Sangam MN',
  'Lucida Grande',
  'Lucida Grande Bold',
  'Luminari',
  'Malayalam MN',
  'Malayalam MN Bold',
  'Malayalam Sangam MN',
  'Malayalam Sangam MN Bold',
  'Marker Felt Thin',
  'Marker Felt Wide',
  'Menlo Bold',
  'Menlo Bold Italic',
  'Menlo Italic',
  'Menlo Regular',
  'Microsoft Sans Serif',
  'Mishafi Gold Regular',
  'Mishafi Regular',
  'Monaco',
  'Mshtakan',
  'Mshtakan Bold',
  'Mshtakan BoldOblique',
  'Mshtakan Oblique',
  'MuktaMahee Bold',
  'MuktaMahee Light',
  'MuktaMahee Medium',
  'MuktaMahee Regular',
  'MuktaMahee SemiBold',
  'Muna Black',
  'Muna Bold',
  'Muna Regular',
  'Myanmar MN',
  'Myanmar MN Bold',
  'Myanmar Sangam MN',
  'Myanmar Sangam MN Bold',
  'Nadeem Regular',
  'New Peninim MT',
  'New Peninim MT Bold',
  'New Peninim MT Bold Inclined',
  'New Peninim MT Inclined',
  'Noteworthy Bold',
  'Noteworthy Light',
  'Noto Nastaliq Urdu',
  'Noto Nastaliq Urdu Bold',
  'Noto Sans Javanese Regular',
  'Noto Sans Kannada Black',
  'Noto Sans Kannada Bold',
  'Noto Sans Kannada ExtraBold',
  'Noto Sans Kannada ExtraLight',
  'Noto Sans Kannada Light',
  'Noto Sans Kannada Medium',
  'Noto Sans Kannada Regular',
  'Noto Sans Kannada SemiBold',
  'Noto Sans Kannada Thin',
  'Noto Sans Myanmar Black',
  'Noto Sans Myanmar Bold',
  'Noto Sans Myanmar ExtraBold',
  'Noto Sans Myanmar ExtraLight',
  'Noto Sans Myanmar Light',
  'Noto Sans Myanmar Medium',
  'Noto Sans Myanmar Regular',
  'Noto Sans Myanmar SemiBold',
  'Noto Sans Myanmar Thin',
  'Noto Sans Oriya',
  'Noto Sans Oriya Bold',
  'Optima Bold',
  'Optima Bold Italic',
  'Optima ExtraBlack',
  'Optima Italic',
  'Optima Regular',
  'Oriya MN',
  'Oriya MN Bold',
  'Oriya Sangam MN',
  'Oriya Sangam MN Bold',
  'PT Mono',
  'PT Mono Bold',
  'PT Sans',
  'PT Sans Bold',
  'PT Sans Bold Italic',
  'PT Sans Caption',
  'PT Sans Caption Bold',
  'PT Sans Italic',
  'PT Sans Narrow',
  'PT Sans Narrow Bold',
  'PT Serif',
  'PT Serif Bold',
  'PT Serif Bold Italic',
  'PT Serif Caption',
  'PT Serif Caption Italic',
  'PT Serif Italic',
  'Palatino',
  'Palatino Bold',
  'Palatino Bold Italic',
  'Palatino Italic',
  'Papyrus',
  'Papyrus Condensed',
  'Party LET Plain',
  'Phosphate Inline',
  'Phosphate Solid',
  'PingFang HK Light',
  'PingFang HK Medium',
  'PingFang HK Regular',
  'PingFang HK Semibold',
  'PingFang HK Thin',
  'PingFang HK Ultralight',
  'PingFang SC Light',
  'PingFang SC Medium',
  'PingFang SC Regular',
  'PingFang SC Semibold',
  'PingFang SC Thin',
  'PingFang SC Ultralight',
  'PingFang TC Light',
  'PingFang TC Medium',
  'PingFang TC Regular',
  'PingFang TC Semibold',
  'PingFang TC Thin',
  'PingFang TC Ultralight',
  'Plantagenet Cherokee',
  'Raanana',
  'Raanana Bold',
  'Rockwell',
  'Rockwell Bold',
  'Rockwell Bold Italic',
  'Rockwell Italic',
  'STIXGeneral-Bold',
  'STIXGeneral-BoldItalic',
  'STIXGeneral-Italic',
  'STIXGeneral-Regular',
  'STIXIntegralsD-Bold',
  'STIXIntegralsD-Regular',
  'STIXIntegralsSm-Bold',
  'STIXIntegralsSm-Regular',
  'STIXIntegralsUp-Bold',
  'STIXIntegralsUp-Regular',
  'STIXIntegralsUpD-Bold',
  'STIXIntegralsUpD-Regular',
  'STIXIntegralsUpSm-Bold',
  'STIXIntegralsUpSm-Regular',
  'STIXNonUnicode-Bold',
  'STIXNonUnicode-BoldItalic',
  'STIXNonUnicode-Italic',
  'STIXNonUnicode-Regular',
  'STIXSizeFiveSym-Regular',
  'STIXSizeFourSym-Bold',
  'STIXSizeFourSym-Regular',
  'STIXSizeOneSym-Bold',
  'STIXSizeOneSym-Regular',
  'STIXSizeThreeSym-Bold',
  'STIXSizeThreeSym-Regular',
  'STIXSizeTwoSym-Bold',
  'STIXSizeTwoSym-Regular',
  'STIXVariants-Bold',
  'STIXVariants-Regular',
  'STSong',
  'Sana Regular',
  'Sathu',
  'Savoye LET Plain:1.0',
  'Shree Devanagari 714',
  'Shree Devanagari 714 Bold',
  'Shree Devanagari 714 Bold Italic',
  'Shree Devanagari 714 Italic',
  'SignPainter-HouseScript',
  'SignPainter-HouseScript Semibold',
  'Silom',
  'Sinhala MN',
  'Sinhala MN Bold',
  'Sinhala Sangam MN',
  'Sinhala Sangam MN Bold',
  'Skia Black',
  'Skia Black Condensed',
  'Skia Black Extended',
  'Skia Bold',
  'Skia Condensed',
  'Skia Extended',
  'Skia Light',
  'Skia Light Condensed',
  'Skia Light Extended',
  'Skia Regular',
  'Snell Roundhand',
  'Snell Roundhand Black',
  'Snell Roundhand Bold',
  'Songti SC Black',
  'Songti SC Bold',
  'Songti SC Light',
  'Songti SC Regular',
  'Songti TC Bold',
  'Songti TC Light',
  'Songti TC Regular',
  'Sukhumvit Set Bold',
  'Sukhumvit Set Light',
  'Sukhumvit Set Medium',
  'Sukhumvit Set Semi Bold',
  'Sukhumvit Set Text',
  'Sukhumvit Set Thin',
  'Symbol',
  'Tahoma',
  'Tahoma Bold',
  'Tamil MN',
  'Tamil MN Bold',
  'Tamil Sangam MN',
  'Tamil Sangam MN Bold',
  'Telugu MN',
  'Telugu MN Bold',
  'Telugu Sangam MN',
  'Telugu Sangam MN Bold',
  'Thonburi',
  'Thonburi Bold',
  'Thonburi Light',
  'Times Bold',
  'Times Bold Italic',
  'Times Italic',
  'Times New Roman',
  'Times New Roman Bold',
  'Times New Roman Bold Italic',
  'Times New Roman Italic',
  'Times Roman',
  'Trattatello',
  'Trebuchet MS',
  'Trebuchet MS Bold',
  'Trebuchet MS Bold Italic',
  'Trebuchet MS Italic',
  'Verdana',
  'Verdana Bold',
  'Verdana Bold Italic',
  'Verdana Italic',
  'Waseem Light',
  'Waseem Regular',
  'Webdings',
  'Wingdings',
  'Wingdings 2',
  'Wingdings 3',
  'Zapf Dingbats',
  'Zapfino',
].map((name) => name.toLowerCase())
